import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetState, StateStatus } from '@guryou/redux';
import { getAllArchivedResources, PERSONNEL_ARCHIVED_GET_MANY, PERSONNEL_ARCHIVED_RESTORE } from '../new/resource';
const useArchivedResources = () => {
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity
  } = useSelector(state => state.resource.archivedResources);
  const restore = useSelector(state => state.resource.restoreArchivedResource);
  useEffect(() => {
    if (status === StateStatus.LOADING) {
      return;
    }
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getAllArchivedResources());
      return;
    }
    if (restore.version) {
      dispatch(resetState(PERSONNEL_ARCHIVED_GET_MANY));
      restore.version && dispatch(resetState(PERSONNEL_ARCHIVED_RESTORE));
    }
  }, [data, dispatch, status, restore.version]);
  useEffect(() => {
    return () => dispatch(resetState(PERSONNEL_ARCHIVED_GET_MANY));
  }, [dispatch]);
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useArchivedResources;